//Changes for on boundary change commited to fast revert to previous logic or fix issue on tests
import React, { useState, useEffect, useRef } from 'react'
import { Checkbox, FormControlLabel } from '@material-ui/core'

import BuilderMapView from '../component/BuilderMapView'
import DrawMap from '../../../Components/DrawMap/container/DrawMap'

import {
  getFeatureFromOverlay,
  getOverlayColorAndOpacity,
  // getFormatedArea,
  filterPostcodes,
  formatFeaturesToOverlays,
} from '../util'
import {
  addFeaturesPFGQL,
  updateFeaturesPFGQL,
  deleteFeaturesPFGQL,
  splitFeaturesPFGQL,
} from '../../../Module/graphQL/PathFinder/pathFinderGQL'
// import { debounce } from '../../../Utils/Functions'
import { BUILDER_MAP_MODE } from '../const'
import PostcodesSearch from '../../../Components/PostcodesSearch/component/PostcodesSearch'
import { showReduxModal, hideReduxModal } from '../../../Reducers/UI/actions'
import { connect } from 'react-redux'
import { createOverlayName } from '../../../Utils/Map'
import { checkIfOverlaysIntersect } from '../util'
import useOverlaysFetch from '../../../Utils/Hooks/useOverlaysFetch'
import { SelectDashboard } from '../../../Components/Form'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import { FILTER_MAP_DENSITY_ENUM } from 'shared/constants'
import { convertArrayToHashMap } from '../../../shared/libraries/dataSets'
import { InputV2 } from '../../../Components/Form/InputV2'
import { GenericButton } from '../../../Components/Buttons/GenericButton'
import Tooltip from '../../../Components/Tooltip/Tooltip'

// let requestId = null

/**
 * Component that renders map that can be used to create polygons and save the against PF in EDIT mode
 * And to toogle existing overlays in the TOGGLE mode
 * @param {string} props.countryCode Country code that will be used in the PF request
 * @param {object} props.mapPosition Map's center
 * @param {object} props.defaultMapPosition Initial map's center
 * @param {string} props.mode Builder map's mode (edit|toggle)
 * @param {function} props.onOverlayClick Will be called on overlay click
 * @param {function} props.processOverlays Lets us encapsulate BuilderMap with only minimal needed logic and keep it highly reusable and flexible
 * Applies specific logic from the parent and returns processed overlays
 * @param {function} props.showReduxModal Show modal window. Added via `connect()` wrapper
 *
 * @returns {JSX.Element} <BuilderMap />
 */

const BuilderMap = ({
  countryCode,
  mapPosition,
  defaultMapPosition,
  mode = BUILDER_MAP_MODE.EDIT,
  onOverlayClick = () => {},
  processOverlays = o => o,
  setModalControls,
  showReduxModal,
  hideReduxModal,
  cityId,
  skipHouseholdsDataOverview = false,
  selectedOverlaysMap,
  setSelectedOverlaysMap,
  canUsePolygonSplit = false,
  filterByCityIdDistributionZone = null,
}) => {
  const [renderedOverlays, setRenderedOverlays] = useState([])
  const [postcodes, setPostcodes] = useState({})
  const [newPostcodes, setNewPostcodes] = useState({})
  const [oldPostcodes, setOldPostcodes] = useState({})
  const [splitedPolygons, setSplitedPolygons] = useState({})
  const [missionBoundaries, setMissionBoundaries] = useState({})
  const [loading, setLoading] = useState(false)
  const [map, setMap] = useState(false)
  const [isDrawing, setIsDrawing] = useState(false)
  const drawingStatusRef = useRef()
  const renderedOverlaysRef = useRef()
  // FR Specific
  const [isIRISVisible, setIsIRISVisibility] = useState(true)
  const [isMissionsVisible, setIsMisionsVisibility] = useState(false)
  const [isShowOldPostcodes, setIsShowOldPostcodes] = useState(false)
  const [isShowNewPostcodes, setIsShowNewPostcodes] = useState(false)
  const [showSplitedPolygons, setShowSplitedPolygons] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState(
    FILTER_MAP_DENSITY_ENUM.ALL,
  )
  const [densityFilterLoaded, setDensityFilterLoaded] = useState(false)
  const [overlaysWithoutPostcodes, setOverlaysWithoutPostcodes] = useState([])
  const [postcodesFromSearch, setPostcodesFromSearch] = useState([])
  const [addressPerPolygon, setAddressPerPolygon] = useState('')
  const [validationErrors, setValidationErrors] = useState({
    addressPerPolygon: null,
  })

  const filterOptions = Object.values(FILTER_MAP_DENSITY_ENUM).map(item => ({
    label: item,
    value: item,
  }))

  const { loadData } = useOverlaysFetch({
    mode,
    countryCode,
    processOverlays,
    filterByCityIdDistributionZone,
  })

  useEffect(() => {
    renderedOverlaysRef.current = renderedOverlays
  }, [renderedOverlays])
  // const MAX_ZOOM = 14
  const shouldShowAdditionalLayer = ['FR', 'BE'].includes(countryCode)
  /**
   * Updates map center
   */

  useEffect(() => {
    if (!map) return
    const centerPosition = mapPosition || defaultMapPosition

    setSelectedFilter(FILTER_MAP_DENSITY_ENUM.ALL)
    map.setCenter(centerPosition)
    map.setZoom(12)
    fetchDataOnInit()
  }, [mapPosition, map])

  /**
   * Update visible overlays
   */
  useEffect(() => {
    if (shouldShowAdditionalLayer && isMissionsVisible) {
      const keyPerContry = {
        'FR': 'codeIRIS',
        'BE': 'statisticalSectorCode',
      }
      const key = keyPerContry[countryCode]
      const overlays = [
        ...Object.values(missionBoundaries).filter(boundary => {
          if (
            !boundary.metadata ||
            [undefined, null].includes(boundary.metadata[key])
          ) {
            return true
          }
          try {
            if (isIRISVisible) {
              return boundary.metadata[key]
            } else {
              return !boundary.metadata[key]
            }
          } catch (error) {
            console.warn(error)
            return true
          }
        }),
        ...postcodesFromSearch,
      ]
      setOverlaysWithoutPostcodes(overlays)
      setRenderedOverlays(overlays)
    } else {
      if (isMissionsVisible) {
        const overlays = [
          ...Object.values(missionBoundaries),
          ...postcodesFromSearch,
        ]
        setOverlaysWithoutPostcodes(overlays)
        setRenderedOverlays(overlays)
      } else {
        const overlays = [...postcodesFromSearch]
        setOverlaysWithoutPostcodes(overlays)
        setRenderedOverlays(overlays)
      }
    }
  }, [
    missionBoundaries,
    Object.keys(postcodes).length,
    postcodesFromSearch.length,
    isIRISVisible,
    isMissionsVisible,
  ])

  useEffect(() => {
    if (isShowOldPostcodes) {
      setRenderedOverlays(prev => [...prev, ...Object.values(oldPostcodes)])
    } else {
      setRenderedOverlays(overlaysWithoutPostcodes)
    }
  }, [isShowOldPostcodes])

  useEffect(() => {
    if (isShowNewPostcodes) {
      setRenderedOverlays(prev => [...prev, ...Object.values(newPostcodes)])
    } else {
      setRenderedOverlays(overlaysWithoutPostcodes)
    }
  }, [isShowNewPostcodes])

  useEffect(() => {
    if (showSplitedPolygons) {
      setRenderedOverlays(prev => [...prev, ...Object.values(splitedPolygons)])
    } else {
      setRenderedOverlays(overlaysWithoutPostcodes)
    }
  }, [showSplitedPolygons])

  useEffect(() => {
    if (loading) {
      setIsShowNewPostcodes(false)
      setIsShowOldPostcodes(false)
      setShowSplitedPolygons(false)
    }
  }, [loading])

  /**
   * Resolves stale state issue for onBoundsChanged
   */
  useEffect(() => {
    drawingStatusRef.current = isDrawing
  }, [isDrawing])
  /**
   * Adds listener so we know when viewbox is changed
   * @param {GMAP} map
   */
  const onMapInit = (newMap, setModalVisible) => {
    if (!newMap || map) return
    // newMap.addListener(
    //   'bounds_changed',
    //   // Using debounce (1s) so we wont spam expensive requests
    //   debounce(() => onBoundsChanged(newMap), 1000),
    // )

    // onBoundsChanged(newMap)

    setMap(newMap)
    setModalControls && setModalControls(setModalVisible)
  }

  const fetchMissionBoundaries = async ({
    layer = 'MissionBoundaries',
    after,
    // area,
    // includeAddressCount,
  }) => {
    const boundaries = await loadData({
      layer,
      // area,
      // includeAddressCount,
      after,
    })

    setMissionBoundaries(previousState => ({
      ...previousState,
      ...boundaries.data,
    }))

    if (boundaries.pageInfo.hasNextPage) {
      await fetchMissionBoundaries({
        layer,
        after: boundaries.pageInfo.endCursor,
        // area,
        // includeAddressCount,
      })
    }
  }

  /**
   * Handles viewbox updates by fetching new overlays for new bounds
   * It wont request households amount if view area is too large for PF to handle
   * @param {GMAP} map
   */

  const fetchPostcodesByChunks = async ({
    after,
    // area,
    // includeAddressCount,
  }) => {
    const postcodes = await loadData({
      layer: 'Postcodes',
      // area,
      // includeAddressCount,
      after,
    })

    const { oldP, newP } = filterPostcodes({
      postcodes: Object.values(postcodes.data),
      countryCode,
    })

    setPostcodes(prev => ({ ...prev, ...oldP, ...newP }))
    setNewPostcodes(prev => ({ ...prev, ...newP }))
    setOldPostcodes(prev => ({ ...prev, ...oldP }))

    if (postcodes.pageInfo.hasNextPage) {
      await fetchPostcodesByChunks({
        after: postcodes.pageInfo.endCursor,
        // area,
        // includeAddressCount,
      })
    }
  }
  const getSplitedPolygons = async (overlays, addressCount, countryCode) => {
    setLoading(true)
    try {
      const selectedPostcodes = Object.values(overlays).map(
        p => p.payload.label,
      )
      Object.values(overlays).map(overlay => onOverlayClick(overlay))
      if (selectedPostcodes.length == 0) return setLoading(false)
      const features = await splitFeaturesPFGQL({
        codes: selectedPostcodes,
        addressCount: Number(addressCount),
        countryCode,
      })

      const formattedOverlays = formatFeaturesToOverlays(features, {})

      const processedOverlays = processOverlays(formattedOverlays)
      const hashMap = convertArrayToHashMap(processedOverlays, 'id')
      setIsShowNewPostcodes(false)
      setIsShowOldPostcodes(false)
      setSplitedPolygons(prev => ({ ...prev, ...hashMap }))
      setShowSplitedPolygons(true)
      setSelectedOverlaysMap([])
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const fetchDataOnInit = async map => {
    // Don't fetch and trigger re-render if user is drawing
    // if (drawingStatusRef.current) return
    try {
      // const latLngBound = map.getBounds()
      // const zoom = map.getZoom()

      // if (!latLngBound) return
      // const formattedArea = await getFormatedArea(latLngBound)
      setLoading(true)
      // const includeAddressCount = zoom > MAX_ZOOM
      // const currentRequestId = Date.now()
      // requestId = currentRequestId

      // if (currentRequestId !== requestId) {
      //   //Race condition occurred
      //   return
      // }

      await fetchPostcodesByChunks({})

      // { area: formattedArea, includeAddressCount }

      if (countryCode === 'FR') {
        await fetchMissionBoundaries({
          layer: 'IRISBoundaries',
          // area: formattedArea,
          // includeAddressCount,
        })
      } else if (countryCode === 'BE') {
        await fetchMissionBoundaries({
          layer: 'BEStatisticalSectors',
          // area: formattedArea,
          // includeAddressCount,
        })
      }
      await fetchMissionBoundaries({
        layer: 'MissionBoundaries',
        // area: formattedArea,
        // includeAddressCount,
      })
    } catch (error) {
      if (error.message.includes('NO_DISTRIBUTION_ZONES_FOUND')) {
        showReduxModal({
          title: 'Warning!',
          children:
            'No distribution zones found for this city, MAP not available',
          confirmLabel: 'OK',
          hideCancel: true,
        })
      }

      console.error('PathFinder error.')
      throw error
    } finally {
      setLoading(false)
    }
  }
  /**
   * Save/update feature on the PF
   * @param {number} param.id Feature's id if already exists
   * @param {array} param.id Feature's boundary
   */
  const onOverlaySave = async ({ id, boundary, overlay, modalContainer }) => {
    if (
      checkIfOverlaysIntersect(
        boundary,
        renderedOverlaysRef.current.filter(({ isPostcode }) => !isPostcode),
        id,
      )
    ) {
      showReduxModal({
        title: 'Mission boundaries overlap',
        children:
          'This mission overlaps with an existing mission. Please move mission or edit boundary if you do not want them to overlap.',
        confirmLabel: 'OK',
        hideCancel: true,
        container: modalContainer,
      })
    }
    try {
      setLoading(true)

      const customName = overlay.payload && overlay.payload.label

      const label = customName
        ? customName
        : await createOverlayName({ countryCode, boundary, renderedOverlays })

      overlay.set('payload', { ...overlay.payload, label })

      if (id) {
        const feature = getFeatureFromOverlay({
          countryCode,
          boundary: boundary,
        })

        const input = {
          features: [
            {
              ...feature,
              properties: {
                id,
                name: label,
                cityId,
              },
            },
          ],
        }
        await updateFeaturesPFGQL(input)
        initOverlay({ featureId: id, boundary, label })
        setLoading(false)
        return { id }
      }
      const feature = getFeatureFromOverlay({
        countryCode,
        boundary: boundary,
      })
      const input = {
        features: [
          {
            ...feature,
            properties: {
              name: label,
              cityId,
            },
          },
        ],
      }
      const response = await addFeaturesPFGQL(input)
      const { data, errors } = await response.json()
      if (errors && errors[0]) throw new Error(errors[0].message)
      const featureId = data.addFeatures.features[0].properties.id
      initOverlay({ featureId, boundary, label })
      return { id: featureId }
    } finally {
      setLoading(false)
    }
  }

  const initOverlay = ({ featureId, boundary, label }) => {
    const isEdit = mode === BUILDER_MAP_MODE.EDIT
    const { color, fillOpacity, strokeOpacity } = getOverlayColorAndOpacity({
      isEdit,
      isPostcode: false,
    })
    const overlay = {
      id: featureId,
      name: label,
      color,
      mapPolygonProps: {
        key: featureId,
        disabled: !isEdit,
        canBeDeleted: isEdit,
        fillOpacity,
        strokeOpacity,
        payload: {
          label,
        },
      },
      paths: [
        boundary.map(({ latitude, longitude }) => ({
          lat: latitude,
          lng: longitude,
        })),
      ],
    }

    setIsMisionsVisibility(true)

    return setMissionBoundaries(missionBoundariesCurrent => {
      return { ...missionBoundariesCurrent, [featureId]: overlay }
    })
  }

  const isSplitDisabled =
    addressPerPolygon < 50 ||
    loading ||
    isMissionsVisible ||
    Object.values(selectedOverlaysMap).length == 0 ||
    Object.values(selectedOverlaysMap).some(
      o => o.payload.type == 'subPolygon',
    ) ||
    validationErrors.addressPerPolygon

  const validateAddressPerPolygon = value => {
    if (Number(value) < 50) {
      return setValidationErrors({
        ...validationErrors,
        addressPerPolygon: 'Must be greater than or equal to 50',
      })
    }
    if (value.includes('.')) {
      return setValidationErrors({
        ...validationErrors,
        addressPerPolygon: 'Must be an integer',
      })
    }
    if (!/^\d+$/.test(value)) {
      return setValidationErrors({
        ...validationErrors,
        addressPerPolygon: 'Only digits allowed',
      })
    }
    setValidationErrors({ ...validationErrors, addressPerPolygon: null })
  }

  /**
   * Delete feature from the PF with confirmation modal
   * @param {number} param.customId Feature's id
   */
  const onOverlayDeleteConfirmation = (
    overlays,
    shouldUpdate = true,
    modalContainer,
  ) =>
    new Promise(resolve => {
      showReduxModal({
        title: 'Delete mission(s) area?',
        onConfirm: () => {
          onOverlayDelete(overlays)
          resolve()
        },
        confirmLabel: 'Delete',
        container: modalContainer,
      })
    })

  /**
   * Delete feature from the PF
   * @param {number} param.customId Feature's id
   */
  const onOverlayDelete = async overlays => {
    setLoading(true)
    const input = {
      features: overlays.map(overlay => ({
        layer: 'MissionBoundaries',
        properties: {
          id: overlay.customId,
        },
      })),
    }
    var temp = renderedOverlays.slice(0)
    temp = renderedOverlays.filter(a => !overlays.find(b => b.customId == a.id))

    setRenderedOverlays(temp)
    setMissionBoundaries(prevMissionBoundaries => {
      const clone = { ...prevMissionBoundaries }
      overlays.forEach(({ customId: deletedId }) => {
        delete clone[deletedId]
      })
      return clone
    })
    await deleteFeaturesPFGQL(input)
    setLoading(false)
  }

  /**
   * Save new active tags to local state
   * @param {array} activeTags Postcodes that were chosen by user
   */
  const onPostcodesUpdate = ({ activePostcodes }) => {
    setPostcodesFromSearch(activePostcodes)
  }
  const getVisibleOverlaysMap = () =>
    renderedOverlays.reduce((acc, overlay) => {
      acc[overlay.id] = true
      return acc
    }, {})

  const shouldShowSplitUI =
    canUsePolygonSplit && ['AU', 'NZ'].includes(countryCode)

  return (
    <BuilderMapView>
      <Row>
        {shouldShowAdditionalLayer ? (
          <Col xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isIRISVisible}
                  onChange={event => setIsIRISVisibility(event.target.checked)}
                  name="IRIS"
                />
              }
              label="Toggle IRIS visibility"
            />
          </Col>
        ) : null}
        <Col xs={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isMissionsVisible}
                onChange={event => setIsMisionsVisibility(event.target.checked)}
                name="missionsVisible"
              />
            }
            label="Toggle missions visibility"
          />
        </Col>
        <Col xs={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isShowOldPostcodes}
                onChange={event => setIsShowOldPostcodes(event.target.checked)}
                name="isShowOldPostcodes"
                disabled={isShowNewPostcodes || showSplitedPolygons}
              />
            }
            label={'Show postcodes'}
          />
        </Col>
        <Col xs={2}>
          {countryCode === 'AU' || countryCode === 'NZ' ? (
            <FormControlLabel
              control={
                <Checkbox
                  checked={isShowNewPostcodes}
                  onChange={event => {
                    setIsShowNewPostcodes(event.target.checked)
                  }}
                  name="isShowNewPostcodes"
                  disabled={isShowOldPostcodes || showSplitedPolygons}
                />
              }
              label={'Show Areas'}
            />
          ) : null}
        </Col>
        <Col xs={3}>
          {shouldShowSplitUI ? (
            <FormControlLabel
              control={
                <Checkbox
                  checked={showSplitedPolygons}
                  onChange={event => {
                    setIsShowNewPostcodes(false)
                    setIsShowOldPostcodes(false)
                    setShowSplitedPolygons(event.target.checked)
                  }}
                  name="showSplitedPolygons"
                  disabled={isShowOldPostcodes || isShowNewPostcodes}
                />
              }
              label={'Show splitted polygons'}
            />
          ) : null}
        </Col>
      </Row>

      <Row
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Col xs={4}>
          <SelectDashboard
            options={filterOptions}
            value={selectedFilter}
            onChange={(a, b, value) => {
              setSelectedFilter(value)
            }}
            disabled={!densityFilterLoaded}
          />
        </Col>

        {shouldShowSplitUI ? (
          <Col xs={2}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {validationErrors.addressPerPolygon && (
                <span
                  style={{
                    color: 'red',
                    fontSize: 10,
                    position: 'absolute',
                    top: -15,
                  }}
                >
                  {`*${validationErrors.addressPerPolygon}`}
                </span>
              )}
              <InputV2
                error={validationErrors.addressPerPolygon}
                placeholder="Address per polygon"
                value={addressPerPolygon}
                onChange={e => {
                  setAddressPerPolygon(e.target.value)
                  validateAddressPerPolygon(e.target.value)
                }}
              />
            </div>
          </Col>
        ) : null}
        {shouldShowSplitUI ? (
          <Col
            xs={1}
            style={{
              height: 22,
              width: 20,
            }}
          >
            <Tooltip
              content={`
                   Enter the desired number of addresses or households you want each polygon to contain after the split.
                   Click 'Apply' to split the currently selected polygons on the map.
                   The system will attempt to divide the polygons equally based on the number you provide. If a polygon cannot be divided equally, the system will prioritize creating polygons with a slightly higher number of addresses than specified.
                   Leaving this field blank will result in no splitting of polygons.`}
            />
          </Col>
        ) : null}
        {shouldShowSplitUI ? (
          <Col xs={1}>
            <GenericButton
              disabled={isSplitDisabled}
              label="Apply"
              customStyles={{ width: '100px' }}
              onClick={async () =>
                showReduxModal({
                  title: 'Confirm Polygon Splitting',
                  children: `Splitting the selected polygons will clear any existing selections. 
                  After the polygons are split, you will need to reselect the desired polygons to create missions.
                   If you need to save your progress, please click on 'Save Campaign' before splitting. 
                   Do you want to proceed?`,
                  confirmLabel: 'Confirm',
                  onConfirm: async () => {
                    hideReduxModal()
                    await getSplitedPolygons(
                      selectedOverlaysMap,
                      addressPerPolygon,
                      countryCode,
                    )
                  },
                })
              }
            />
          </Col>
        ) : null}
        <Col xs={shouldShowSplitUI ? 4 : 8}>
          <PostcodesSearch
            countryCode={countryCode}
            onUpdate={onPostcodesUpdate}
          />
        </Col>
      </Row>
      <DrawMap
        onMapInit={onMapInit}
        onSave={onOverlaySave}
        initialOverlays={renderedOverlays}
        onDelete={onOverlayDeleteConfirmation}
        countryCode={countryCode}
        shouldPickWeek={false}
        loading={loading}
        onOverlayClick={onOverlayClick}
        hideMapControls={mode === BUILDER_MAP_MODE.TOGGLE}
        skipHouseholdsDataOverview={
          mode === BUILDER_MAP_MODE.EDIT || skipHouseholdsDataOverview
        }
        mapOptions={{
          center: mapPosition || defaultMapPosition,
        }}
        mapControls={['DRAW']}
        onDrawingChange={setIsDrawing}
        visibleOverlaysMap={getVisibleOverlaysMap()}
        filter={selectedFilter}
        onFilterLoaded={setDensityFilterLoaded}
      />
    </BuilderMapView>
  )
}

const mapDispatchToProps = { showReduxModal, hideReduxModal }

export default connect(
  null,
  mapDispatchToProps,
)(BuilderMap)
